export default __webpack_public_path__ + "static/media/wheat.9731bc1c.png";